import { Map } from 'immutable';
import actions from '@synergycms_app/store/actions';

export default {
  SEND: (type, text, timeout = 10000) => {
    return (dispatch, getState) => {
      const store = getState();
      const notifications = store.get('notifications');
      const id = notifications.size + 1;

      dispatch(actions.notifications.show(id, type, text));
      setTimeout(() => {
        dispatch(actions.notifications.hide(id));
      }, timeout);
    };
  },
  SHOW: (id, type, text) => {
    return (dispatch, getState) => {
      const store = getState();
      const notifications = store.get('notifications');
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
      return notifications.push(Map({ id, type, text }));
    };
  },
  HIDE: id => {
    return (dispatch, getState) => {
      const store = getState();
      const notifications = store.get('notifications');

      const index = notifications.findIndex(n => n.get('id') === id);
      if (index >= 0) {
        return notifications.delete(index);
      }

      return notifications;
    };
  }
};
